export enum InventorySettingsTabs {
  PREFERENCES = 'preferences',
  COMMODITIES = 'commodities',
  WAREHOUSES = 'warehouses',
}
